import * as React from 'react'
import { RadioButton } from '../radio-button/radio-button';
import Label from '@components/atoms/typography/Label/label';

export interface ILabeledRadioButtonProps {
	label?: string;
	description?: string;
	value: string;
	id?: string;
}

const LabeledRadioButton: React.FC<ILabeledRadioButtonProps & React.ComponentPropsWithoutRef<typeof RadioButton>> = ({
	label,
	description,
	value,
	id,
	...props
}) => {
	const radioId = id || `radio-${value}`;

	return (
		<div className="flex flex-row items-center gap-2 min-w-0">
			<RadioButton {...props} value={value} id={radioId} />
			{label && (
				<Label htmlFor={radioId} label={label} description={description} weight="medium" className="cursor-pointer" />
			)}
		</div>
	);
};

export { LabeledRadioButton };
